/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {LogsPerformatico as ɵa,createPerformanceLogger as ɵb} from './lib/log-performatico';